var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGraudate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_164_6959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2 22.0004C13.2 12.2802 21.0797 4.40039 30.8 4.40039H83.6C93.3202 4.40039 101.2 12.2802 101.2 22.0004V74.8004C101.2 84.5206 93.3202 92.4004 83.6 92.4004H30.7999C21.0797 92.4004 13.2 84.5206 13.2 74.8004V22.0004Z",
    fill: "url(#paint0_linear_164_6959)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 79.2002H33V17.6006H82.5V79.2002Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_6959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7497 29.4258C57.1232 29.4258 56.5045 29.5341 55.9167 29.7429L34.2218 37.5778C33.487 37.8485 32.9997 38.5446 32.9997 39.3258C32.9997 40.107 33.487 40.803 34.2218 41.0738L38.7 42.6902C37.4315 44.6857 36.7122 47.0447 36.7122 49.5274V51.7008C36.7122 53.8973 35.8769 56.1635 34.9875 57.9502C34.4847 58.9556 33.9124 59.9456 33.2472 60.8583C32.9997 61.1909 32.9301 61.624 33.0693 62.0184C33.2086 62.4129 33.5334 62.7068 33.9356 62.8073L38.8856 64.0448C39.2104 64.1299 39.5585 64.0681 39.8446 63.8902C40.1308 63.7123 40.3319 63.4184 40.3938 63.0858C41.0589 59.7755 40.7264 56.8055 40.2314 54.6785C39.9839 53.5802 39.6513 52.4588 39.1872 51.4301V49.5274C39.1872 47.1916 39.9761 44.9873 41.3451 43.2239C42.3429 42.0251 43.6345 41.0583 45.1504 40.4627L57.2934 35.6906C57.9276 35.4431 58.6469 35.7525 58.8944 36.3867C59.1419 37.0209 58.8325 37.7402 58.1983 37.9877L46.0554 42.7598C45.0963 43.1388 44.2532 43.7189 43.5649 44.4305L55.9089 48.8855C56.4968 49.0943 57.1155 49.2026 57.742 49.2026C58.3685 49.2026 58.9872 49.0943 59.575 48.8855L81.2777 41.0738C82.0125 40.8108 82.4997 40.107 82.4997 39.3258C82.4997 38.5446 82.0125 37.8485 81.2777 37.5778L59.5828 29.7429C58.995 29.5341 58.3762 29.4258 57.7497 29.4258ZM42.8997 58.507C42.8997 61.2373 49.5513 64.0758 57.7497 64.0758C65.9482 64.0758 72.5997 61.2373 72.5997 58.507L71.4164 47.2613L60.4181 51.2367C59.5596 51.5461 58.6546 51.7008 57.7497 51.7008C56.8448 51.7008 55.9321 51.5461 55.0814 51.2367L44.0831 47.2613L42.8997 58.507Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_164_6959",
    x: -0.0000495911,
    y: 0.000390053,
    width: 114.4,
    height: 114.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_164_6959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_164_6959",
    result: "effect2_dropShadow_164_6959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_164_6959",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_6959",
    x1: -17.9127,
    y1: 35.5131,
    x2: 44.3127,
    y2: 97.7385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4685D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_6959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9993 26.9512H82.4993V66.5512H32.9993V26.9512Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGraudate);
export default __webpack_public_path__ + "static/media/ic_graudate.b3e4fa76e79b81e202899f133877616e.svg";
export { ForwardRef as ReactComponent };